import { PreparedWorkload } from 'features/workload-optimization';

import { useShowHpaV2 } from '../../_hooks/permissions/useShowHpaV2';
import { HorizontalRightsizingSettings } from './_components/HorizontalRightsizingSettings/HorizontalRightsizingSettings';
import { HorizontalRightsizingSettingsV2 } from './_components/HorizontalRightsizingSettingsV2/HorizontalRightsizingSettingsV2';

type Props = {
  workload: PreparedWorkload;
};

/**
 * Renders V1 or V2 HPA rightsizing UI based on showHpaV2.
 * Legacy workloads under showHpaV2 still use HorizontalRightsizingSettingsV2
 * (which branches to HpaSettingsLegacyForm internally).
 */
export const RightsizingHpaSettings = ({ workload }: Props) => {
  const { showHpaV2 } = useShowHpaV2();

  if (showHpaV2) {
    return <HorizontalRightsizingSettingsV2 workload={workload} />;
  }

  return <HorizontalRightsizingSettings />;
};
